var _path, _path2, _path3, _ellipse, _ellipse2, _ellipse3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTodayBonusStars(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 56,
    viewBox: "0 0 40 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.323 13.2255C38.7138 13.0478 38.7137 12.4927 38.323 12.3151L30.829 8.90873C30.5985 8.80369 30.4139 8.62046 30.3076 8.39272L26.8514 0.972976C26.6719 0.587809 26.1243 0.587811 25.9449 0.972976L22.4886 8.39272C22.3823 8.62046 22.1969 8.80368 21.9672 8.90873L14.4733 12.3151C14.0825 12.4927 14.0825 13.0478 14.4732 13.2255L21.9672 16.6327C22.1969 16.7377 22.3823 16.9209 22.4886 17.1478L25.9449 24.5683C26.1243 24.9535 26.672 24.9535 26.8514 24.5683L30.3076 17.1478C30.4139 16.9209 30.5985 16.7377 30.829 16.6327L38.323 13.2255Z",
    fill: "#E6126A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.3464 21.1568C15.7372 20.9791 15.7372 20.4241 15.3464 20.2464L10.9757 18.2597C10.8299 18.1933 10.7132 18.0774 10.646 17.9334L8.62704 13.5993C8.44763 13.2141 7.89998 13.2141 7.72056 13.5993L5.70164 17.9334C5.6344 18.0774 5.51714 18.1933 5.37191 18.2597L1.00121 20.2464C0.610438 20.4241 0.610412 20.9791 1.00117 21.1568L5.37191 23.144C5.51714 23.2104 5.6344 23.3262 5.70164 23.4697L7.72055 27.8043C7.89996 28.1895 8.44764 28.1895 8.62705 27.8043L10.646 23.4697C10.7132 23.3262 10.8299 23.2104 10.9757 23.144L15.3464 21.1568Z",
    fill: "#F15A29"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.9119 39.4666C22.3026 39.2889 22.3026 38.7339 21.9118 38.5563L20.0339 37.7026C19.9557 37.667 19.8932 37.6049 19.8571 37.5277L18.9854 35.6563C18.806 35.2711 18.2583 35.2711 18.0789 35.6563L17.2071 37.5277C17.1711 37.6049 17.1082 37.667 17.0304 37.7026L15.1525 38.5563C14.7617 38.7339 14.7617 39.2889 15.1524 39.4666L17.0304 40.3205C17.1082 40.3561 17.1711 40.4181 17.2071 40.495L18.0789 42.3667C18.2583 42.7519 18.806 42.7519 18.9854 42.3667L19.8571 40.495C19.8932 40.4181 19.9557 40.3561 20.0339 40.3205L21.9119 39.4666Z",
    fill: "#005E9D"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 29.4039,
    cy: 53.7844,
    rx: 1.71429,
    ry: 1.69023,
    transform: "rotate(-180 29.4039 53.7844)",
    fill: "#7E3F97"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.14802,
    cy: 36.7953,
    rx: 1.71428,
    ry: 1.69025,
    transform: "rotate(-180 3.14802 36.7953)",
    fill: "#3EB5E5"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 35.148,
    cy: 27.5496,
    rx: 1.71429,
    ry: 1.69023,
    transform: "rotate(-180 35.148 27.5496)",
    fill: "#143860"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTodayBonusStars);
export default __webpack_public_path__ + "static/media/today-bonus-stars.5f327464c89957279607e5072673544d.svg";
export { ForwardRef as ReactComponent };